export default __webpack_public_path__ + "80054c5198d4dcd42a2b02fc98dcd322.png";